import { ref } from 'vue'

// The quick switcher (⌘K: groups, channels, friends; ⇧⌘O: just the current group's channels) is
// one dialog mounted in app.vue and opened from the global shortcuts — this shared state is how
// they reach it.

export type QuickSwitcherMode = 'all' | 'channels'

const isOpen = ref(false)
const mode = ref<QuickSwitcherMode>('all')

export function useQuickSwitcher() {
  function open(next: QuickSwitcherMode = 'all') {
    mode.value = next
    isOpen.value = true
  }

  function toggle(next: QuickSwitcherMode = 'all') {
    if (isOpen.value && mode.value === next) isOpen.value = false
    else open(next)
  }

  return { isOpen, mode, open, toggle }
}
